<template>
    <v-container style="height: 100vh" class="d-flex align-center" fluid>
        <v-row>
            <h1>Authenticating Telegram</h1>
            <p>Associating Telegram to your Swiset user...</p>
            <!--script='<script async src="https://telegram.org/js/telegram-widget.js?11" data-telegram-login="SwisetBot" data-size="medium" data-auth-url="https://app.swiset.com/telegram" data-request-access="write"></script>'></TelegramSignin !-->
        </v-row>
    </v-container>
</template>

<script>
    import Repository from '../../../repositories/telegram';
    import { mapMutations } from 'vuex';
    export default {
        name: "ConnectTelegram",
        data() {
            return {
                authBack: false,
            };
        },
        mounted() {
            this.reviewTelegramPostAuth();
        },
        methods: {
            ...mapMutations(['setTelegramId']),
            reviewTelegramPostAuth() {
                let telegramId = this.$route.query.id;
                let telegramPhotoUrl = this.$route.query.photo_url;
                if(telegramId !== undefined) {
                    this.authBack = true;
                    let telegramData = {
                        userId: this.$store.state.user.id,
                        telegramId: telegramId,
                        telegramPhotoUrl: (telegramPhotoUrl !== undefined)? telegramPhotoUrl : null,
                    };
                    Repository.associateTelegramUser(telegramData).then((response) => {
                        if(response.status < 400 && response.data) {
                            this.setTelegramId(telegramId);
                            alert('Telegram successfully associated');
                            this.$router.push('/profile');
                        }
                    });
                }
                else {
                    alert('Telegram was not associated.');
                    this.$router.push('/profile');
                }
            },
        }
    }
</script>

<style scoped>

</style>
